import React from 'react';
import { useParams } from 'react-router-dom';
import { Square, Stack } from '@grubhubprod/gh-cookbook-react';
import PageHeader from 'src/components/enterprise/layout/PageHeader';
import { PageTitle } from 'src/components/enterprise/layout/PageTitle/PageTitle';
import { ReportsTable } from 'src/components/enterprise/features/Reporting/ManageReportsPage/components/ReportsTable/ReportsTable';
import { Breadcrumbs } from 'src/components/Breadcrumbs/Breadcrumbs';
import { getHomeBreadcrumb } from 'src/constants/urls';

export const ManageReportsPage: React.FC = () => {
  const { corpid: corpId } = useParams<{ corpid: string }>();

  return (
    <Square inset="lg">
      <Stack y="lg">
        <PageHeader>
          <PageTitle title="Reports" />
          <Breadcrumbs
            breadcrumbs={[
              {
                label: 'Admin home',
                ...getHomeBreadcrumb(corpId),
              },
            ]}
          />
        </PageHeader>
        <ReportsTable />
      </Stack>
    </Square>
  );
};
